"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DraftListContainer = void 0;
const react_1 = __importStar(require("react"));
const react_timeago_1 = __importDefault(require("react-timeago"));
const context_1 = require("../../../shared/context");
const sdk_1 = require("../../sdk");
const DraftList = ({ list }) => {
    return (react_1.default.createElement("div", { className: "draft-list" },
        react_1.default.createElement("div", { className: "draft-list__title" },
            "Drafts",
            react_1.default.createElement("div", { className: "draft-list__actions" },
                react_1.default.createElement("a", { href: "/drafts/new", className: "button action s" }, "Create new draft"))),
        react_1.default.createElement("div", { className: "draft-list__content" }, list.length
            ? list.map((item) => {
                return (react_1.default.createElement("a", { className: "draft-list__item", key: item.id, href: `/drafts/${item.id}` },
                    react_1.default.createElement("div", { className: "draft-list__item-title" }, item.title),
                    react_1.default.createElement("div", { className: "draft-list__item-meta" },
                        "updated ",
                        react_1.default.createElement(react_timeago_1.default, { date: item.updatedAt, minPeriod: 10 }))));
            })
            : 'You have no drafts')));
};
exports.DraftListContainer = () => {
    const ctx = react_1.useContext(context_1.AppContext);
    const [draftsList, setDraftsList] = react_1.useState();
    if (!ctx.user) {
        return react_1.default.createElement("div", null, "Sign in to view your drafts");
    }
    if (draftsList) {
        return react_1.default.createElement(DraftList, { list: draftsList });
    }
    else {
        sdk_1.sdk.getDraftsList().then(setDraftsList).catch(sdk_1.sdk.reportClientError);
        return react_1.default.createElement("div", null); // TODO loader?
    }
};
//# sourceMappingURL=DraftsList.js.map